module.exports = __webpack_public_path__ + "img/swat-team-02.e1d690c.png";